export default function Loader() {
  return (
    <div className="graph-loading">
      <div className="loader">
        <div className="container">
          <div className="dot dot-1" />
          <div className="dot dot-2" />
          <div className="dot dot-3" />
        </div>
      </div>
    </div>
  );
}
